export default __webpack_public_path__ + "static/media/newLoader.111ab07a.gif";